export const HIERARCHY = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    TERTIARY: 'tertiary',
    QUAD: 'quad',
    DESTRUCT: 'destruct',
    TOOLBAR: 'toolbar'
};

// This makes Hierarchy a union of the values of HIERARCHY
export type Hierarchy = (typeof HIERARCHY)[keyof typeof HIERARCHY];

export const SIZE = {
    SMALL: 'sm',
    MEDIUM: 'md',
    LARGE: 'lg'
};

export type Size = (typeof SIZE)[keyof typeof SIZE];

export const INPUT_TYPE = {
    TEXT: 'text',
    PASSWORD: 'password',
    NUMBER: 'number',
    // Passed straight through to the input, so this is the browser's own date picker. Its value is an
    // ISO `YYYY-MM-DD` string, which sorts lexically and needs no parsing to store.
    DATE: 'date'
};

export type InputVariant = (typeof INPUT_VARIANT)[keyof typeof INPUT_VARIANT];

export const INPUT_VARIANT = {
    SEARCH: 'search',
    SEND: 'send'
};

export type InputType = (typeof INPUT_TYPE)[keyof typeof INPUT_TYPE];

export const LABEL_POSITION = {
    BEFORE: 'before',
    AFTER: 'after'
};

export type LabelPosition = (typeof LABEL_POSITION)[keyof typeof LABEL_POSITION];
